import { useDocumentDetails } from 'hooks/useDocumentDetails';
import type { Document } from 'types';
import type { EnvironmentalResourcePermit } from 'types/Documents';

export const useEnvironmentalResourcePermit = (id: string | null) =>
  useDocumentDetails<Document<EnvironmentalResourcePermit> | null>(id);
